import { Badge, Box, IconButton } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import { FiBell } from 'react-icons/fi'

import {
  PopoverBody,
  PopoverContent,
  PopoverRoot,
  PopoverTrigger,
} from '@/components/ui/popover'
import { useNotifications } from '@/hooks/useNotifications'

import { NotificationsList } from './NotificationsList'

export function NotificationsPopover() {
  const { t } = useTranslation('notifications')
  // Unread-only query so the bell badge reflects the exact total unread count.
  const { unreadCount } = useNotifications({ read: 'unread', showToast: false })

  return (
    <PopoverRoot positioning={{ placement: 'bottom-end' }}>
      <PopoverTrigger asChild>
        <Box position="relative" display="inline-flex">
          <IconButton aria-label={t('title')} variant="ghost" size="md">
            <FiBell size={24} />
          </IconButton>
          {unreadCount > 0 && (
            <Badge
              position="absolute"
              top="0"
              right="0"
              transform="translate(25%, -25%)"
              minW="5"
              h="5"
              px="1"
              display="flex"
              alignItems="center"
              justifyContent="center"
              fontSize="xs"
              fontWeight="bold"
              borderRadius="full"
              colorPalette="red"
              variant="solid"
              boxShadow="0 1px 2px rgba(0,0,0,0.2)"
              _dark={{ boxShadow: '0 1px 2px rgba(0,0,0,0.4)' }}
            >
              {unreadCount > 99 ? '99+' : unreadCount}
            </Badge>
          )}
        </Box>
      </PopoverTrigger>
      <PopoverContent
        minW="380px"
        maxW="95vw"
        borderRadius="xl"
        overflow="hidden"
        borderWidth="1px"
        borderColor="border"
        shadow="lg"
      >
        <PopoverBody p={0}>
          <NotificationsList />
        </PopoverBody>
      </PopoverContent>
    </PopoverRoot>
  )
}
